import React, { useState, useEffect, useMemo } from "react";
import useEmpresa from "../../../../hooks/useEmpresa";
import Text from "../../../../components/Common/Text";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomSeparator from "../../../../components/Common/CustomSeparator";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import PropTypes from "prop-types";
import CheckRender from "../../../../components/Common/CheckRender";
import CustomCheckbox from "../../../../components/CustomForm/CustomCheckbox";
import Colors from "../../../../themes/Colors";

const ProcedimientosStandVirtualSeleccionarDocumentos = ({
  documentos,
  tipoProcedimiento,
  onGuardarSeleccionados
}) => {
  const empresa = useEmpresa();
  const [documentosSeleccionados, setDocumentosSeleccionados] = useState([
    ...documentos
  ]);

  useEffect(() => {
    setDocumentosSeleccionados([...documentos]);
  }, [documentos]);

  const handleGuardar = () => {
    const seleccionados = documentosSeleccionados.filter(
      (item) => item.seleccionado
    );
    onGuardarSeleccionados(seleccionados);
  };

  const columnas = useMemo(
    () => [
      {
        title: "Tipo Documento",
        dataIndex: "nombreDocumento",
        key: "nombreDocumento",
        width: "80%"
      },
      {
        title: "Requerido",
        dataIndex: "requerido",
        key: "requerido",
        width: "20%",
        render: (_text, record) => (
          <CustomCheckbox
            disabled={record.porDefecto}
            checked={record.requerido}
            checkedColor={empresa?.COLOR_PRINCIPAL}
            uncheckedColor={Colors.blueTransparent}
            checkmarkColor={Colors.white}
            onChange={(checked) => {
              const isChecked =
                typeof checked === "boolean"
                  ? checked
                  : !!(
                      checked?.target?.checked ??
                      checked?.value?.target?.checked
                    );

              setDocumentosSeleccionados((prevState) =>
                prevState.map((item) =>
                  item.documento === record.documento
                    ? { ...item, requerido: isChecked }
                    : item
                )
              );
            }}
          />

          // <input
          //   key={record.documento}
          //   type="checkbox"
          //   disabled={record.porDefecto}
          //   id={record.documento}
          //   name={record.documento}
          //   checked={record.requerido}
          //   onChange={(e) =>
          //     setDocumentosSeleccionados((prevState) =>
          //       prevState.map((item) =>
          //         item.documento === record.documento
          //           ? { ...item, requerido: e.target.checked }
          //           : item
          //       )
          //     )
          //   }
          // />
        )
      },
      {
        title: "Seleccionar",
        dataIndex: "Documento",
        key: "Documento",
        width: "20%",
        render: (_text, record) => (
          <CustomCheckbox
            disabled={record.porDefecto}
            checked={record.seleccionado}
            checkedColor={empresa?.COLOR_PRINCIPAL}
            uncheckedColor={Colors.blueTransparent}
            checkmarkColor={Colors.white}
            onChange={(checked) => {
              const isChecked =
                typeof checked === "boolean"
                  ? checked
                  : !!(
                      checked?.target?.checked ??
                      checked?.value?.target?.checked
                    );

              setDocumentosSeleccionados((prevState) =>
                prevState.map((item) =>
                  item.documento === record.documento
                    ? { ...item, seleccionado: isChecked }
                    : item
                )
              );
            }}
          />
        )
      }
    ],
    []
  );

  return (
    <>
      <Section>
        <Text size="16px" weight={"bold"} isTittle={true}>
          {"Seleccionar Documentos"}
        </Text>
      </Section>

      <CheckRender allowed={tipoProcedimiento?.cobertura}>
        <Section>
          <Text size="14px" weight={"bold"} color={empresa?.COLOR_PRINCIPAL}>
            {`${tipoProcedimiento.descripcion} (${tipoProcedimiento.cobertura})`}
          </Text>
        </Section>
      </CheckRender>

      <Section>
        <CustomTable
          columns={columnas}
          dataSource={documentosSeleccionados}
          showPagination={false}
          pageSize={10}
          width={"100%"}
          minHeight={"300px"}
          maxHeight={"400px"}
        />
      </Section>

      <CustomSeparator height={"30px"} />

      <Section justifyContent={"flex-end"}>
        <CustomButton
          label={"Guardar"}
          width={"200px"}
          onClick={() => handleGuardar()}
        />
      </Section>
    </>
  );
};

ProcedimientosStandVirtualSeleccionarDocumentos.propTypes = {
  documentos: PropTypes.arrayOf(
    PropTypes.shape({
      documento: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired, // Identificador único del documento
      nombreDocumento: PropTypes.string.isRequired, // Nombre del documento
      requerido: PropTypes.bool.isRequired, // Indica si el documento es requerido
      seleccionado: PropTypes.bool.isRequired, // Indica si el documento está seleccionado
      porDefecto: PropTypes.bool // Indica si el documento es por defecto (opcional)
    })
  ).isRequired, // Lista de documentos
  tipoProcedimiento: PropTypes.shape({
    descripcion: PropTypes.string.isRequired, // Descripción del procedimiento
    codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired // Código del procedimiento
  }).isRequired, // Información del tipo de procedimiento
  onGuardarSeleccionados: PropTypes.func.isRequired, // Función para manejar la acción de guardar los documentos seleccionados
  isLoading: PropTypes.bool // Indica si el botón de guardar está en estado de carga
};

export default ProcedimientosStandVirtualSeleccionarDocumentos;
